const getTaskColor = (difficulty) => {
        switch (difficulty) {
            case 'easy':
                return 'rgb(141, 252, 215, 0.80)';  // Vert
            case 'medium':
                return 'rgb(255, 224, 173, 0.80)';  // Bleu
            case 'hard':
                return 'rgba(255, 49, 49, 0.28)';   // Violet
            default:
                return 'rgb(75, 255, 195)';  // Gris par défaut
        }
    };

export default getTaskColor;